import React from 'react';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import styled from 'styled-components';
import { CustomSingleQuestion } from 'admin/pages/ManageAccounts/CustomQuestions/utilts';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { RenderHtml } from './utils';

interface CustomQuestionTopProps {
  title: string;
  helperText?: string;
  questionType: CustomSingleQuestion['questionType'];
}

const StyledDiv = styled.div`
  text-align: left;
  margin-bottom: ${SPACERS.small};
  .helper-text {
    margin-top: ${SPACERS.extraTiny};
    color: ${COLORS.grayDark};
  }
`;

const CustomQuestionTop: React.FC<CustomQuestionTopProps> = ({
  title,
  helperText,
}) => {
  return (
    <StyledDiv>
      <TrueImpactText variant="body-bold">
        <RenderHtml text={title} />
      </TrueImpactText>
      {helperText && (
        <TrueImpactText className="helper-text" variant="body-small">
          <RenderHtml text={helperText} />
        </TrueImpactText>
      )}
    </StyledDiv>
  );
};

export default CustomQuestionTop;
